var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhArrowDownThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.83 146.83L130.83 218.83C130.458 219.202 130.017 219.497 129.532 219.698C129.046 219.9 128.525 220.003 128 220.003C127.474 220.003 126.954 219.9 126.468 219.698C125.982 219.497 125.541 219.202 125.17 218.83L53.1698 146.83C52.4192 146.079 51.9976 145.061 51.9976 144C51.9976 142.939 52.4192 141.921 53.1698 141.17C53.9203 140.419 54.9383 139.998 55.9998 139.998C57.0612 139.998 58.0792 140.419 58.8298 141.17L124 206.34V40C124 38.9391 124.421 37.9217 125.171 37.1716C125.922 36.4214 126.939 36 128 36C129.061 36 130.078 36.4214 130.828 37.1716C131.578 37.9217 132 38.9391 132 40V206.34L197.17 141.17C197.92 140.419 198.938 139.998 200 139.998C201.061 139.998 202.079 140.419 202.83 141.17C203.58 141.921 204.002 142.939 204.002 144C204.002 145.061 203.58 146.079 202.83 146.83Z",
    fill: "#EBEBEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhArrowDownThin);
export default __webpack_public_path__ + "static/media/ph_arrow-down-thin.9f62eeee868b46d8077331ff2a4dd457.svg";
export { ForwardRef as ReactComponent };